import { render, staticRenderFns } from "./EditCashbook.vue?vue&type=template&id=263469ba&"
import script from "./EditCashbook.vue?vue&type=script&lang=js&"
export * from "./EditCashbook.vue?vue&type=script&lang=js&"
import style0 from "./EditCashbook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports